import { PresetsSkeletonProps } from '../add-ons-presets-modal.type';

const SKELETON_ROWS = [0, 1, 2];

export const PresetsSkeleton = ({ dataTestId }: PresetsSkeletonProps) => (
  <div className='flex flex-col gap-2 animate-pulse' data-testid={dataTestId}>
    {SKELETON_ROWS.map((index) => (
      <div key={index} className='h-12 rounded-md bg-tertiary' />
    ))}
  </div>
);
